import { FC } from 'react';

import { IoIosArrowDropup } from 'react-icons/io';

import { colors } from '~/constants/colors';

import { BackToPageTopContainer } from './styles';
import { TypographSpan } from '../typograph';

export const BackToPageTop: FC = () => {
  const handleClick = (): void => {
    const root = document.getElementById('root');
    root.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <BackToPageTopContainer onClick={handleClick}>
      <IoIosArrowDropup color={colors.green} size={22} />
      <TypographSpan
        uppercase
        size={16}
        bold
        lineHeight={20.8}
        color={colors.text_white}
      >
        voltar ao topo
      </TypographSpan>
    </BackToPageTopContainer>
  );
};
